import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { Icon } from "react-icons-kit";
import { eye } from "react-icons-kit/feather/eye";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import "./style.scss";
import { httpService } from "../../base/services/httpService.service";
import { LocalStorageService } from "../../base/services/local-storage.service";

function ForgotPasswordSetNew() {
   const navigate = useNavigate();
   const [type, setType] = useState("password");
   const [icon, setIcon] = useState(eyeOff);
   const userID = LocalStorageService.getItem("userId");

   const handleToggle = () => {
      if (type === "password") {
         setIcon(eye);
         setType("text");
      } else {
         setIcon(eyeOff);
         setType("password");
      }
   };
   const successCallback = () => {
      navigate("/auth/login");
   };

   const initialValues = {
      newPassword: "",
      confirmPassword: ""
   };
   const PasswordSchema = Yup.object().shape({
      newPassword: Yup.string()
         .min(3, "Minimum 3 symbols")
         .max(50, "Maximum 50 symbols")
         .required("Required"),
      confirmPassword: Yup.string()
         .label("confirm password")
         .required()
         .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
   });

   const submitNewPassword = (values) => {
      httpService.post(
         "/account/resetpassword",
         {
            userId: userID,
            newPassword: values.newPassword,
            confirmNewPassword: values.confirmPassword
         },
         (data) => {
            successCallback();
         }
      );
   };

   return (
      <>
         <div className="login-form login-signin" style={{ display: "block" }}>
            <div className="text-center mb-5 mb-lg-10">
               <h2>GET STARTED WITH KAPorg</h2>
               <p>Create new password</p>
            </div>

            <Formik
               initialValues={initialValues}
               validationSchema={PasswordSchema}
               onSubmit={(values) => {
                  submitNewPassword(values);
               }}
            >
               {({ handleSubmit, handleChange, values, errors, touched }) => (
                  <form
                     onSubmit={handleSubmit}
                     className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
                  >
                     <div className="form-group fv-plugins-icon-container">
                        <label>New Password</label>
                        <div className="password-section">
                           <input
                              className={`form-control h-auto py-5 px-6`}
                              type={type}
                              name="newPassword"
                              onChange={handleChange}
                              values={values.newPassword}
                           />
                           <span className="eyeButton" onClick={handleToggle}>
                              <Icon className="icon" icon={icon} size={20} />
                           </span>
                        </div>
                        {errors.newPassword && touched.newPassword ? (
                           <div className="error-message">{errors.newPassword}</div>
                        ) : null}{" "}
                     </div>
                     <div className="form-group fv-plugins-icon-container">
                        <label>Confirm password</label>
                        <div className="password-section">
                           <input
                              className={`form-control h-auto py-5 px-6`}
                              type={type}
                              name="confirmPassword"
                              onChange={handleChange}
                              values={values.confirmPassword}
                           />
                           <span className="eyeButton" onClick={handleToggle}>
                              <Icon className="icon" icon={icon} size={20} />
                           </span>
                        </div>
                        {errors.confirmPassword && touched.confirmPassword ? (
                           <div className="error-message">{errors.confirmPassword}</div>
                        ) : null}{" "}
                     </div>

                     <div className="d-flex justify-content-around">
                        <button
                           type="submit"
                           typkt_login_signin_forme="submit"
                           className="btn btn-next font-weight-bold px-25 py-4 my-3 mx-4 "
                        >
                           Submit
                        </button>
                     </div>
                  </form>
               )}
            </Formik>

            <div></div>
         </div>
      </>
   );
}

export default ForgotPasswordSetNew;
